export default __webpack_public_path__ + "static/media/NP_logo_edge.4bd4dcc8.png";